import { Injectable } from '@angular/core';
import { formatRut, validateRut } from 'rutlib';

@Injectable({
  providedIn: 'root',
})
export class ConfigRutService {
  ///Metodo que formatea el rut
  changeRut(rut2: any): { formattedRut: string, validation: boolean } {
    let rut: string = rut2.target.value;
    const formattedRut: string = formatRut(rut);
    const validation = validateRut(formattedRut);
    return { formattedRut, validation };
  }

  isRutValid(rut: string): boolean{
    const formattedRut: string = formatRut(rut);
    const validation = validateRut(formattedRut);
    return validation;
  }

  transformStringRut(rut: string) :number {
    const cleanedRutWithoutDots = rut.replace(/\./g, '');

    const userRut = parseInt(
      cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
    );

    return userRut
  }

  public formatRutWithDv (rut: number): string {
    const rutString = rut.toString();
  
    // Calcula el dígito verificador
    let sum = 0;
    let multiplier = 2;
    for (let i = rutString.length - 1; i >= 0; i--) {
      sum += parseInt(rutString.charAt(i), 10) * multiplier;
      multiplier = multiplier < 7 ? multiplier + 1 : 2;
    }
  
    const remainder = 11 - (sum % 11);
    let dv = '';
    if (remainder === 11) {
      dv = '0';
    } else if (remainder === 10) {
      dv = 'K';
    } else {
      dv = remainder.toString();
    }
  
    // Formatear el RUT
    let formattedRut = '';
    let count = 0;
    for (let i = rutString.length - 1; i >= 0; i--) {
      formattedRut = rutString.charAt(i) + formattedRut;
      count++;
      if (count === 3 && i !== 0) {
        formattedRut = '.' + formattedRut;
        count = 0;
      }
    }
  
    return `${formattedRut}-${dv}`;
  }

  public formatRutListWithDv(rutList: string[]): string[] {
    return rutList.map(rut => {
      const rutString = rut.toString();
  
      // Calcula el dígito verificador
      let sum = 0;
      let multiplier = 2;
      for (let i = rutString.length - 1; i >= 0; i--) {
        sum += parseInt(rutString.charAt(i), 10) * multiplier;
        multiplier = multiplier < 7 ? multiplier + 1 : 2;
      }
  
      const remainder = 11 - (sum % 11);
      let dv = '';
      if (remainder === 11) {
        dv = '0';
      } else if (remainder === 10) {
        dv = 'K';
      } else {
        dv = remainder.toString();
      }
  
      // Formatear el RUT
      let formattedRut = '';
      let count = 0;
      for (let i = rutString.length - 1; i >= 0; i--) {
        formattedRut = rutString.charAt(i) + formattedRut;
        count++;
        if (count === 3 && i !== 0) {
          formattedRut = '.' + formattedRut;
          count = 0;
        }
      }
  
      return `${formattedRut}-${dv}`;
    });
  }
  

}
